@file:OptIn(kotlin.uuid.ExperimentalUuidApi::class)

package com.yogaaicoach.pages.dashboard

import com.yogaaicoach.common.network.serializers.UuidSerializer
import com.yogaaicoach.pages.trainingprogram.AgeGroupKey
import com.yogaaicoach.pages.trainingprogram.DayAndDuration
import com.yogaaicoach.pages.trainingprogram.LevelKey
import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

@Serializable
data class DashboardData(
    val dashboardItems: List<DashboardItem>,
    val totalMinutes: Int,
    val totalWorkouts: Int,
    val thisWeekGoal: Int,
    val thisWeekCompleted: Int,
    val thisWeekMinutes: Int,
    val lastWeekGoal: Int,
    val lastWeekCompleted: Int,
    val lastWeekMinutes: Int,
    val trainingProgram: TrainingProgramSummary? = null,
    val hasPreviousProgram: Boolean,
    val streakInWeeks: Int,
    val refreshToken: Boolean? = null
)

@Serializable
data class TrainingProgramSummary(
    @Serializable(with = UuidSerializer::class) val guid: Uuid? = null,
    val goals: List<String>,
    val level: LevelKey? = null,
    val ageGroup: AgeGroupKey? = null,
    val schedule: List<DayAndDuration> = emptyList()
)

// Mirrors MainGoal.title's English text (composeApp's Compose-resource-coupled extension
// property) for the enum-name strings TrainingProgramSummary.goals carries on the wire.
fun mainGoalDisplayName(goalName: String): String = when (goalName) {
    "PHYSICAL_STRENGTH" -> "Physical Strength"
    "BALANCE_AND_COORDINATION" -> "Balance and Coordination"
    "POSTURE_AND_ALIGNMENT" -> "Posture and Alignment"
    "MOBILITY_AND_FLEXIBILITY" -> "Mobility and Flexibility"
    else -> goalName
}

@Serializable
data class DashboardItem(
    @Serializable(with = UuidSerializer::class) val workoutGuid: Uuid,
    val duration: Int,
    val focusAreas: String,
    val datePlanned: LocalDate,
    val dateCompleted: LocalDate?,
    val isNextWorkout: Boolean
)
